const waiting = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m2.012-12a.5.5 0 0 1 .416.777L8.286 8l2.142 3.223a.5.5 0 0 1-.416.777H5.988a.5.5 0 0 1-.416-.777L7.713 8 5.572 4.777a.5.5 0 0 1-.074-.18l-.01-.097a.5.5 0 0 1 .5-.5Z"/></svg>',
};

export { waiting as default };
